(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["profil-sante-pastilles"] && !Shopify.designMode) return;
  try {
    
  const tracks = document.querySelectorAll('[data-pastilles]')
  if (!tracks.length) return

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v))

  tracks.forEach((track) => {
    const slider = track.closest('[data-pastilles-slider]')
    const root = slider.closest('.profil-sante-section-pastilles__content') || slider.parentElement
    const activeBox = root.querySelector('[data-active-pastille]')
    const activeTitle = activeBox?.querySelector('[data-active-title]')
    const activeDesc = activeBox?.querySelector('[data-active-description]')
    const cta = root.querySelector('[data-pastille-cta]')

    const items = Array.from(track.querySelectorAll('[data-pastille]'))
    if (!items.length) return

    const hasOverflow = () => track.scrollWidth > track.clientWidth + 2

    // --- Center gutters (1ère et dernière peuvent être centrées)
    const updateCenterPadding = () => {
      const first = items[0]
      if (!first) return

      const itemW = first.getBoundingClientRect().width || 175
      const pad = Math.max(0, track.clientWidth / 2 - itemW / 2)

      track.style.paddingLeft = `${pad}px`
      track.style.paddingRight = `${pad}px`
    }

    // --- Effet + active = plus proche du centre
    const applyStyles = () => {
      const MIN_SCALE = 0.86
      const MIN_OPACITY = 0.55
      const RADIUS = track.clientWidth * 0.55

      const trackRect = track.getBoundingClientRect()
      const centerX = trackRect.left + track.clientWidth / 2

      let activeIdx = 0
      let bestDist = Infinity

      items.forEach((el, idx) => {
        const r = el.getBoundingClientRect()
        const elCenter = r.left + r.width / 2
        const dist = Math.abs(elCenter - centerX)

        if (dist < bestDist) {
          bestDist = dist
          activeIdx = idx
        }

        const t = clamp(dist / RADIUS, 0, 1)
        const eased = 1 - t * t * (3 - 2 * t) // smoothstep inversé

        const scale = MIN_SCALE + (1 - MIN_SCALE) * eased
        const opacity = MIN_OPACITY + (1 - MIN_OPACITY) * eased

        el.style.transform = `scale(${scale.toFixed(3)})`
        el.style.opacity = opacity.toFixed(3)
      })

      const activeEl = items[activeIdx]
      if (activeEl && activeDesc) {
        if (activeTitle) activeTitle.textContent = activeEl.dataset.title || ''
        const src = activeEl.querySelector('[data-pastille-richtext]')
        activeDesc.innerHTML = src ? src.innerHTML : ''
      }
      if (cta) {
        const url = activeEl?.dataset?.url?.trim() || '#'
        cta.href = url || '#'
      }
      items.forEach((el, idx) => el.classList.toggle('is-active', idx === activeIdx))
    }
    const getActiveIndexByCenter = () => {
      const trackRect = track.getBoundingClientRect()
      const centerX = trackRect.left + track.clientWidth / 2

      let bestIdx = 0
      let bestDist = Infinity

      items.forEach((el, idx) => {
        const r = el.getBoundingClientRect()
        const elCenter = r.left + r.width / 2
        const d = Math.abs(elCenter - centerX)
        if (d < bestDist) {
          bestDist = d
          bestIdx = idx
        }
      })

      return bestIdx
    }

    const snapToCenter = () => {
      const idx = getActiveIndexByCenter()
      const el = items[idx]
      if (!el) return

      const trackRect = track.getBoundingClientRect()
      const elRect = el.getBoundingClientRect()

      const trackCenter = trackRect.left + track.clientWidth / 2
      const elCenter = elRect.left + elRect.width / 2

      const delta = elCenter - trackCenter
      track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' })
    }
    // scroll -> re-render
    let raf = 0
    let snapTimer = 0

    track.addEventListener(
      'scroll',
      () => {
        // 1) update styles pendant scroll
        if (!raf) {
          raf = requestAnimationFrame(() => {
            raf = 0
            applyStyles()
          })
        }

        // 2) snap quand idle (trackpad/wheel)
        clearTimeout(snapTimer)
        snapTimer = window.setTimeout(() => {
          if (isDown || isInertia) return
          snapToCenter()
        }, 110)
      },
      { passive: true }
    )

    // --- Drag to scroll (desktop) + inertia (mouse events only)
    const DRAG_THRESHOLD = 6

    let isDown = false
    let startX = 0
    let startScrollLeft = 0
    let didDrag = false
    let lastX = 0
    let lastT = 0
    let velocity = 0
    let inertiaRaf = 0
    let isInertia = false
    const stopInertia = () => {
      if (!inertiaRaf) return
      cancelAnimationFrame(inertiaRaf)
      inertiaRaf = 0
      isInertia = false
    }

    const startInertia = () => {
      const FRICTION = 0.5
      const MIN_V = 0.02

      isInertia = true

      const step = () => {
        velocity *= FRICTION

        if (Math.abs(velocity) < MIN_V) {
          stopInertia()
          isInertia = false
          snapToCenter()
          return
        }

        track.scrollLeft += velocity * 16
        inertiaRaf = requestAnimationFrame(step)
      }

      inertiaRaf = requestAnimationFrame(step)
    }

    const onMouseDown = (e) => {
      if (e.button !== 0) return // left click only
      if (!hasOverflow()) return

      e.preventDefault()
      stopInertia()

      isDown = true
      track.classList.add('is-dragging')

      startX = e.clientX
      startScrollLeft = track.scrollLeft

      lastX = e.clientX
      lastT = performance.now()
      velocity = 0
      didDrag = false
    }

    const onMouseMove = (e) => {
      if (!isDown) return
      e.preventDefault()

      if (Math.abs(e.clientX - startX) > DRAG_THRESHOLD) didDrag = true

      const x = e.clientX
      const dx = x - startX
      track.scrollLeft = startScrollLeft - dx

      const now = performance.now()
      const dt = now - lastT
      if (dt > 0) {
        const vx = (x - lastX) / dt
        const target = -vx
        velocity = velocity * 0.8 + target * 0.2
        lastX = x
        lastT = now
      }
    }

    const onMouseUp = () => {
      if (!isDown) return
      isDown = false
      track.classList.remove('is-dragging')

      if (Math.abs(velocity) > 0.05) {
        startInertia()
      } else {
        snapToCenter()
      }
    }

    track.addEventListener('mousedown', onMouseDown)
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
    window.addEventListener('blur', onMouseUp)

    track.addEventListener('dragstart', (e) => e.preventDefault())

    // helper: centre un item précis
    const centerItem = (el) => {
      const trackRect = track.getBoundingClientRect()
      const elRect = el.getBoundingClientRect()

      const trackCenter = trackRect.left + track.clientWidth / 2
      const elCenter = elRect.left + elRect.width / 2

      const delta = elCenter - trackCenter
      track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' })
    }

    track.addEventListener('click', (e) => {
      if (didDrag || isDown || isInertia) return
      const item = e.target.closest('[data-pastille]')
      if (!item) return
      centerItem(item)
    })
    window.addEventListener('resize', () => {
      updateCenterPadding()
      applyStyles()
    })

    updateCenterPadding()
    applyStyles()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profil-sante-quizz"] && !Shopify.designMode) return;
  try {
    
  function openQuizModal(e) {
    e.preventDefault()
    document.getElementById('open-profil-fute-modal')?.click()
  }
  document
    .querySelectorAll('#lp-start-quiz, #lp-find-pastilles, #lp-get-pastille, .lp-gift-banner-cta')
    .forEach((el) => el.addEventListener('click', openQuizModal))

  // ============================
  // SCROLL-TRIGGERED ANIMATIONS
  // ============================
  ;(() => {
    if (!('IntersectionObserver' in window)) return

    const SECTION_SELECTOR =
      '.profil-sante-section-banner, .profil-sante-section-pastilles, .profil-sante-section-steps__step'

    const setupScrollFade = () => {
      const animatedElements = document.querySelectorAll(SECTION_SELECTOR)
      if (!animatedElements.length) return

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return

            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateY(0)'
            observer.unobserve(entry.target)
          })
        },
        { threshold: 0.15 }
      )

      animatedElements.forEach((el) => {
        if (el.dataset.scrollFadeReady === 'true') return

        el.dataset.scrollFadeReady = 'true'

        if (reduceMotion) {
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'
        } else {
          el.style.opacity = '0'
          el.style.transform = 'translateY(30px)'
          el.style.transition = 'opacity 0.6s ease, transform 0.6s ease'
          observer.observe(el)
        }
      })
    }

    setupScrollFade()
    document.addEventListener('shopify:section:load', setupScrollFade)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-sante-franchise"] && !Shopify.designMode) return;
  try {
    

function initSsfGalleries(root) {

  root.querySelectorAll('[data-ssf-gallery]').forEach(function (gallery) {

    if (gallery.dataset.ssfReady === 'true') return;

    gallery.dataset.ssfReady = 'true';

    var track = gallery.querySelector('[data-ssf-gallery-track]');

    var prev = gallery.querySelector('[data-ssf-gallery-prev]');

    var next = gallery.querySelector('[data-ssf-gallery-next]');

    if (!track || !prev || !next) return;

    function step(direction) {

      var card = track.querySelector('.ssf__gallery-card');

      if (!card) return;

      var gap = parseFloat(getComputedStyle(track).gap) || 0;

      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });

    }

    prev.addEventListener('click', function () { step(-1); });

    next.addEventListener('click', function () { step(1); });

  });

}



function focusSsfSuccess(root) {

  var success = root.querySelector('[data-ssf-form-success]');

  if (!success) return;

  window.setTimeout(function () {

    success.scrollIntoView({ behavior: 'smooth', block: 'center' });

    success.focus({ preventScroll: true });

  }, 150);

}



function initSsfFranchiseForms(root) {

  root.querySelectorAll('.ssf__form-card form').forEach(function (form) {

    if (form.dataset.ssfMondayReady === 'true') return;

    form.dataset.ssfMondayReady = 'true';



    form.addEventListener('submit', async function (event) {

      if (form.dataset.ssfMondaySent === 'true') return;

      if (!form.checkValidity()) return;



      event.preventDefault();



      var button = form.querySelector('button[type="submit"]');

      var errorBox = form.querySelector('[data-ssf-submit-error]');

      var originalLabel = button ? button.textContent : '';



      if (errorBox) errorBox.hidden = true;

      if (button) {

        button.disabled = true;

        button.textContent = button.getAttribute('data-loading-label') || 'Envoi en cours…';

      }



      var getValue = function (name) {

        var field = form.querySelector('[name="' + name + '"]');

        return field ? field.value.trim() : '';

      };



      var getCheckedValue = function (name) {

        var field = form.querySelector('[name="' + name + '"]:checked');

        return field ? field.value : '';

      };



      var payload = {

        firstName: getValue('contact[Prénom]'),

        lastName: getValue('contact[Nom]'),

        email: getValue('contact[email]'),

        phone: getValue('contact[Téléphone]'),

        cityProvince: getValue('contact[Ville / Province]'),

        profession: getValue('contact[Profession ou expérience]'),

        market: getValue('contact[Marché visé]'),

        capital: getCheckedValue('contact[Capital liquide disponible]'),

        timeline: getCheckedValue('contact[Délai du projet]'),

        message: getValue('contact[body]'),

        language: document.documentElement.lang && document.documentElement.lang.toLowerCase().indexOf('en') === 0 ? 'English' : 'Français'

      };



      try {

        var response = await fetch('https://shopsante-franchise-leads.zacary-santos.workers.dev/', {

          method: 'POST',

          headers: { 'Content-Type': 'application/json' },

          body: JSON.stringify(payload)

        });

        var result = await response.json();



        if (!response.ok || !result.ok) {

          throw new Error('Monday submission failed');

        }



        form.dataset.ssfMondaySent = 'true';

        form.submit();

      } catch (error) {

        if (errorBox) {

          errorBox.hidden = false;

          errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });

        }

        if (button) {

          button.disabled = false;

          button.textContent = originalLabel;

        }

      }

    });

  });

}



function initSsf(root) {

  initSsfGalleries(root);

  initSsfFranchiseForms(root);

  focusSsfSuccess(root);

}



document.addEventListener('DOMContentLoaded', function () { initSsf(document); });

document.addEventListener('shopify:section:load', function (event) { initSsf(event.target); });


  } catch(e) { console.error(e); }
})();
})();
